
import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import TemporaryDrawer from './../components/Drawer'
import { useSelector } from "react-redux";
import AccountCircle from '@mui/icons-material/AccountCircle';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Link from '@mui/material/Link';
import EditIcon from '@mui/icons-material/Edit';
import CommentIcon from '@mui/icons-material/Comment';
// import { useNavigate } from "react-router-dom";
// import { NavigateTo } from '../utils/auth_helper';
// import { redirect } from "react-router-dom";


function ResponsiveAppBar() {

  // const navigate = useNavigate();

  const { auth_user } = useSelector((state) => state.authUser)
  console.log('---AppBar.js--auth_user:', auth_user)

  const [anchorEl, setAnchorEl] = React.useState(null);
  const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = React.useState(null);

  const isMenuOpen = Boolean(anchorEl);
  // const isMobileMenuOpen = Boolean(mobileMoreAnchorEl);

  const handleProfileMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMobileMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    handleMobileMenuClose();
  };

  // const handleMobileMenuOpen = (event) => {
  //   setMobileMoreAnchorEl(event.currentTarget);
  // };

  const handleHomeClick = () => {
    let navigate_link = '/'
    if (auth_user.user_type == 'Employee') {
      navigate_link = '/emp/bid-listing'
    } else if (auth_user.user_type == 'Seller') {
      navigate_link = '/seller/emp-bid-listing'
    }
    // console.log('---navigate_link:', navigate_link)
    // navigate(navigate_link)
    // NavigateTo(navigate_link)
  // return redirect(navigate_link);
  return navigate_link;
  }

  const menuId = 'primary-search-account-menu';
  const renderMenu = (
    <Menu
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      id={menuId}
      keepMounted
      transformOrigin={{
        vertical: 'top',
        horizontal: 'right',
      }}
      open={isMenuOpen}
      onClose={handleMenuClose}
    >
      <MenuItem onClick={handleMenuClose}>{auth_user.user_full_name} &nbsp;
        { auth_user.is_logged_in && auth_user.user_type == 'Employee' && 
          <Link href="/emp/update-profile"><EditIcon/></Link>
        }
        { auth_user.is_logged_in && auth_user.user_type == 'Seller' && 
          <Link href="/seller/update-profile"><EditIcon/></Link>
        }
      </MenuItem>
      { auth_user.is_logged_in && auth_user.user_type == 'Seller' && 
        <MenuItem onClick={handleMenuClose}>
          <Link href="/seller/feedback">Send Feedback <CommentIcon/></Link>
        </MenuItem>
      }
      <MenuItem onClick={handleMenuClose}><Link href="/seller/logout">Logout</Link></MenuItem>
    </Menu>
  );

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static">
        <Toolbar>

          {auth_user.is_logged_in && auth_user.user_type == 'Employee' && <TemporaryDrawer />}

          <a className="tw-flex tw-items-center" href="/">
          <img className='tw-ml-2' src="/medib_logo.png" width="40" />
          <span className="tw-text-2xl tw-ml-2">Seller Bids</span>
          </a>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>

          </Typography>

          {
            auth_user.is_logged_in && 
          
          <IconButton
              size="large"
              edge="end"
              aria-label="account of current user"
              aria-controls="userProfileId"
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
            >
              <AccountCircle />
            </IconButton>
          }

          {/* {!auth_user.is_logged_in && <Button href="/seller/request-otp-to-login" color="inherit">Login</Button>}
          {auth_user.is_logged_in && <Button href="/seller/logout" color="inherit">Logout</Button>} */}

        </Toolbar>
      </AppBar>
      {renderMenu}
    </Box>
  );
}


export default ResponsiveAppBar;